export const getIsGdpr = (marketCode?: string) => {
  if (!marketCode || typeof marketCode !== 'string') {
    return false;
  }

  const gdprMarkets = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'IS',
    'LI',
    'NO'
  ];

  return gdprMarkets.includes(marketCode.toUpperCase());
};
